export const graphqlErrorMessages = {
  NotAuthorized: 'Not Authorized',
  Login: 'Please log in to continue',
  InternalServerError: 'Internal Server Error',
  InvalidArguments: 'Invalid Arguments',
  CSRFTokenError: 'CSRF Token Mismatch',
  DeprecatedCreateInteractionFromSampleBehavior:
    'Creating an interaction from a sample without Sample:CreateNewInteraction. This behavior is deprecated as of 2024-01-10 per SQS-342',
};
